import React, { createContext, PropsWithChildren, useState } from "react";

interface ConfirmState {
  prompt: string;
  body?: string | null;
  isOpen: boolean;
  proceed: null | ((value?: unknown) => void);
  cancel: null | ((reason?: any) => void);
}
export type ContextType = [ConfirmState, (arg0: ConfirmState) => void];

export const ConfirmContext = createContext<ContextType | undefined>(undefined);

const ConfirmContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [confirm, setConfirm] = useState<ConfirmState>({
    prompt: "",
    body: null,
    isOpen: false,
    proceed: null,
    cancel: null,
  });

  return <ConfirmContext.Provider value={[confirm, setConfirm]}>{children}</ConfirmContext.Provider>;
};

export default ConfirmContextProvider;
